import resolveConfig from "tailwindcss/resolveConfig"
import config from "/tailwind.config.js"

const { theme } = resolveConfig(config)

export const colors = theme.colors

const fontFamilyArray = theme.fontFamily.sans
export const fontFamily = "'" + fontFamilyArray.join("', '") + "'"
